import React from 'react';
import { ShieldCheck, Globe, Clock, HeartHandshake } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function SolutionsSection() {
  const {
    t
  } = useLanguage();
  const features = [{
    icon: <ShieldCheck className="w-6 h-6 text-brand-copper" data-id="element-543" />,
    title: t('solutions.quality'),
    description: t('solutions.qualityDesc')
  }, {
    icon: <Globe className="w-6 h-6 text-brand-copper" data-id="element-544" />,
    title: t('solutions.certs'),
    description: t('solutions.certsDesc')
  }, {
    icon: <Clock className="w-6 h-6 text-brand-copper" data-id="element-545" />,
    title: t('solutions.results'),
    description: t('solutions.resultsDesc')
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-brand-copper" data-id="element-546" />,
    title: t('solutions.support'),
    description: t('solutions.supportDesc')
  }];
  return <section id="why-choose" className="py-24 bg-brand-bg" data-id="element-547">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-548">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-549">
          <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-550">
            {t('solutions.label')}
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" data-id="element-551">
            {t('solutions.title1')}{' '}
            <span className="font-semibold" data-id="element-552">{t('solutions.title2')}</span>
          </h3>
          <p className="text-gray-600" data-id="element-553">{t('solutions.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-554">
          {features.map((feature, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-card hover:-translate-y-1 transition-transform duration-300 border border-gray-100" data-id="element-555">
              <div className="w-12 h-12 bg-brand-lightCopper/30 rounded-full flex items-center justify-center mb-6" data-id="element-556">
                {feature.icon}
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-557">
                {feature.title}
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-558">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}